var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-page',{attrs:{"title":"Store Management"}},[_c('import-result',{staticClass:"q-mt-lg",attrs:{"data":_vm.data}}),_c('q-card-section',[_c('q-btn',{attrs:{"color":"secondary","text-color":"white","label":"Close"},on:{"click":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }